import { NgModule } from '@angular/core';
import { SendCoachMessagePage } from './send-coach-message';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [
        SendCoachMessagePage,
    ],
    imports: [
        PagesModule,
        ComponentsModule,
    ],
    exports: [
        SendCoachMessagePage,
    ]
})
export class SendCoachMessagePageModule { }
